/**
 * Lienzo de widgets del Inicio: los tableros del cargo (CIMS0037 →
 * catálogo CIMS0036) con la MISMA tarjeta que Mi escritorio (Tarjewid del
 * kit): cabecera con el nombre, tamaño S/M/L y widget montado por lazy
 * import desde su ruta del catálogo. Registrar un widget es un INSERT en
 * la parametría; el front no opina (FASE 5, root/cimaapi#355).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {Array} graphs  Filas del catálogo del cargo (con GRARUTAX)
 * @param {object} refs   Refs por GRACOMXX para desplazarse a un widget (opcional)
 */
import React from "react";
import Tarjewid from "../../Tablerox/Tarjewid";

const convertirPrimeraMayuscula = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();

//Compatibilidad con filas del catalogo sin GRARUTAX parametrizado (dato de
//la tabla CIMS0036, no de este codigo): antes de la ruta parametrizada,
//el widget se ubicaba por convencion a partir de GRACOMXX. Sin esto, un
//registro con GRARUTAX vacio no pinta nada (root/cimaapi#382, hallazgo de
//Oscar Rosero 2026-09-18: dejaba TODO el lienzo del Inicio en blanco).
const rutaDe = (graph) =>
  graph?.GRARUTAX || `Builders/Bugrafx/Graphics/${convertirPrimeraMayuscula(graph?.GRACOMXX ?? "")}`;

export function Bugraphs({ graphs, refs = {} }) {
  const widgets = (graphs ?? [])
    .filter((graph) => graph?.GRARUTAX || graph?.GRACOMXX)
    .map((graph) => ({ ...graph, GRARUTAX: rutaDe(graph) }));
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "1%", rowGap: 12 }}>
      {widgets.map((widget) => (
        <Tarjewid key={widget.GRAIDXXX} widget={widget} refTarjeta={refs[widget.GRACOMXX] ?? null} />
      ))}
    </div>
  );
}

export default Bugraphs;
